import React, { useMemo } from "react";
import GenericFormTab from "../shippment/tabs/GenericFormTab";
import { doorlocHeaderFields } from "./DoorLocFields";

export default function ViewDoorloc({ initialValues = {}, onCancel }) {
  const headerData = useMemo(() => {
    return {
      ...initialValues,
      editdate: initialValues?.editdate
        ? new Date(initialValues.editdate).toLocaleDateString("en-GB")
        : "",
    };
  }, [initialValues]);

  return (
    <>
      <div className="mb-3 border-bottom pb-2 d-flex gap-4 text-primary fw-semibold">
        <span className="text-muted">Door Location Header</span>
      </div>

      <div className="card mb-4 border-0 shadow-none">
        <GenericFormTab
          fields={doorlocHeaderFields}
          formData={headerData}
          readOnly
        />
      </div>

      <div className="d-flex justify-content-center mt-4">
        <button className="btn btn-secondary" onClick={onCancel}>
          Back
        </button>
      </div>
    </>
  );
}